// Hook que consume el AuthContext.
//
// Usar en cualquier component que necesite leer el state o disparar acciones
// de auth. Lanza si se llama fuera de un <AuthProvider> — error rápido en dev.

import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './AuthProvider';

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth debe usarse dentro de un <AuthProvider>');
  }
  return ctx;
}
